import { stumble } from '@ipfabric/frontend-shared-assets/utils/stumble/stumble';
import type {
  GraphPathLookupParameters,
  PathLookupCheckExistsRequestBody,
  PathLookupCheckExistsResponseBody,
} from '@ipfabric/utils';
import { isPathLookupGraphMetadata } from 'components/Graph/GraphState';
import { extractPresetSettings } from 'components/Graph/helpers/extractPresetSettings';
import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';

export interface FetchPathLookupCheckInitialExpectedPassingTrafficCommand {
  parameters: GraphPathLookupParameters;
}

export const fetchPathLookupCheckInitialExpectedPassingTraffic: GraphCommandFactory<
  FetchPathLookupCheckInitialExpectedPassingTrafficCommand
> = (cmdContext) => async (command) => {
  const response = await cmdContext.api.request<
    PathLookupCheckExistsResponseBody,
    PathLookupCheckExistsRequestBody
  >({
    url: '/graphs/path-lookup/checks/exists',
    method: 'POST',
    data: {
      parameters: command.parameters,
      settings: extractPresetSettings(cmdContext.getState().pathlookup.preset),
    },
  });

  cmdContext.updateState((draft) => {
    if (!isPathLookupGraphMetadata(draft.graphMetadata)) {
      stumble(
        'trying to fetch initial expected passing traffic while no pathlookup is loaded',
      );
      return;
    }
    draft.graphMetadata.initialExpectedPassingTraffic = response.exists
      ? (response.expectedPassingTraffic ?? null)
      : null;
  });
};
